import React from "react";

import { zeroPaddingText } from "../../libs/Util";
import SideModal from "../../atoms/SideModal";
import { ReactComponent as IncompleteMark } from "../../assets/svg/check-mark.svg";
import { ReactComponent as CompleteMark } from "../../assets/svg/check-circle.svg";
import { VideoChapterIssues } from "../../state";

import styles from "./SelectAnswersModal.module.scss";

interface Props {
  parentPositionTop: string;
  parentPositionLeft: string;
  lessonName: string;
  lessonTitle: string;
  teachingMaterialName: string;
  issues: VideoChapterIssues[];
  retrospectiveWorkTitle?: string;
  handleClose: () => void;
  handleClickIssue: (issueId: number) => void;
}

const SelectAnswersModal = ({
  parentPositionTop,
  parentPositionLeft,
  lessonName,
  lessonTitle,
  teachingMaterialName,
  issues,
  retrospectiveWorkTitle,
  handleClose,
  handleClickIssue,
}: Props) => {
  return (
    <SideModal
      onClose={handleClose}
      parentPositionTop={parentPositionTop}
      parentPositionLeft={parentPositionLeft}
    >
      <div className={styles.titleContainer}>
        <p className={styles.name}>
          {teachingMaterialName} {lessonName}
        </p>
        <p className={styles.title}>{lessonTitle}</p>
      </div>
      <hr />
      <div className={styles.contentContainer}>
        {issues.map(issue => (
          <div key={issue.id} className={styles.content}>
            {issue.is_completed ? <CompleteMark /> : <IncompleteMark />}
            <p onClick={() => handleClickIssue(issue.id)}>
              {issue.title === retrospectiveWorkTitle
                ? "振り返り"
                : zeroPaddingText(issue.title).replace("ワーク", "WORK")}
            </p>
          </div>
        ))}
      </div>
    </SideModal>
  );
};

export default SelectAnswersModal;
